<template>
    <div class="basis" v-wechat-title='$route.meta.title'>
      <basislist :basis='list'></basislist>
    </div>
</template>
<script>
import basislist from './basislist'
export default {
    data() {
    return {
      linkid: null,
      title:'',
      list: [],
      loading: false,
      finished: false
    };
  },
  components:{
    basislist
  },
  methods: {
    onLoad() {
      // 异步更新数据
      setTimeout(() => {
        for (let i = 0; i < 10; i++) {
          this.list.push(this.list.length + 1);
        }
        // 加载状态结束
        this.loading = false;

        // 数据全部加载完成
        if (this.list.length >= 40) {
          this.finished = true;
        }
      }, 500);
    },
    getlist(){
      this.$http({
        method: 'get',
        url: '/groupdetail',
        params: {
          groupid: this.$route.query.id
        },
      })
        .then((res) => {
          if (res['data']['Code'] === 0) {
             if(res['data']["Data"]&&res['data']["Data"].length>0){
               this.list = res['data']["Data"]
             }
          } else {
            this.$toast(res['data']["Message"])
          }
        })
        }
  },
  beforeCreate () {
  document.title = this.$route.query.title
  },
  mounted() {
    this.linkid = this.$route.query.id;
    this.title = this.$route.query.title
    this.getlist()
  }
}
</script>
<style scoped lang="scss">
    .basis{
        padding: 1rem;

    }
</style>




// WEBPACK FOOTER //
// src/components/basisExperience.vue